import React, { Fragment } from 'react';
import { Table } from 'reactstrap';
import IconButton from 'components/Button/IconButton';
import trashIcon from 'assets/img/trash-icon.svg';
import editIcon from 'assets/img/edit-icon.svg';
import plusIcon from 'assets/img/plus-icon.svg';

import {
  Head, HeadRow, Th, BodyRow, Td, TextButtonStyled,
} from './styles';

const LocalsTable = ({
  locals, toggleDeleteModal, toggleEditModal, toggleServiceForm,
}) => (
  <Fragment>
    {locals && locals.addresses && locals.addresses.length > 0 && (
      <Table>
        <Head>
          <HeadRow>
            <Th>Endereço</Th>
            <Th>Cidade</Th>
            <Th>Código</Th>
            <Th />
          </HeadRow>
        </Head>
        <tbody>
          {locals.addresses.map((local) => {
            const address = local.address ? local.address : '';
            const number = local.number ? `, ${local.number}` : '';
            const details = local.address_details ? ` - ${local.address_details}` : '';
            return (
              <BodyRow key={local.id}>
                <Td>{`${address}${number}${details}`}</Td>
                <Td>{local.city_name}</Td>
                <Td>{local.external_id}</Td>
                <Td className="actions">
                  <span className="icons">
                    <IconButton btnIcon={trashIcon} onClick={() => toggleDeleteModal(local)} />
                    <IconButton btnIcon={editIcon} onClick={() => toggleEditModal(local)} />
                  </span>
                  <TextButtonStyled
                    btnIcon={plusIcon}
                    noShadow
                    btnWidth="150px"
                    onClick={() => toggleServiceForm(local)}
                  >
                    Novo pedido
                  </TextButtonStyled>
                </Td>
              </BodyRow>
            );
          })}
        </tbody>
      </Table>
    )}
  </Fragment>
);

export default LocalsTable;
